/**
 * Cart Tier Gifts — multi-threshold free gift rewards (CART_TIER_GIFT offers)
 * Cart tier gift lines use private _gift properties (hidden at checkout).
 * Discount is applied ONLY by the app flash-deal function — theme shows cart.js prices as-is.
 */
(function () {
  'use strict';

  function getCartSheetRoot() {
    return document.getElementById('mm-cart-drawer-v2') || document.getElementById('mm-cart-sheet');
  }

  var O = window.MMOffers || {};
  var state = {
    offer: null,
    tiers: [],
    settings: {},
    giftMode: 'TIERS',
    autoReplaceGiftOnUpgrade: false,
    lastTierIndex: -1,
    lastSyncedTierIdx: -1,
    lastUnlockedTierIdx: -1,
    lastAutoClaimTierIdx: -1,
    popupOpen: false,
    loading: false,
    syncInFlight: false,
    tierBootstrapped: false,
    uiActivated: false,
    unlockReady: false,
    claimingGift: false,
    popupPromptedTier: -1
  };

  var POPUP_SEEN_KEY = 'mm_ctg_seen_tiers_v1';
  var GIFT_OPT_OUT_KEY = 'mm_ctg_gift_opt_out_v1';
  var syncScheduleId = 0;
  var syncTimer = null;

  var TIER_MINOR_DIV = 1000;

  /** Divisor used by cart.js line prices on this storefront (100 or 1000). */
  function shopMoneyDiv() {
    var d = parseInt(document.documentElement.getAttribute('data-mm-money-divisor'), 10);
    if (d === 100 || d === 1000) return d;
    var cfg = window.MM_CART_SHEET_CONFIG && parseInt(window.MM_CART_SHEET_CONFIG.moneyDivisor, 10);
    if (cfg === 100 || cfg === 1000) return cfg;
    return TIER_MINOR_DIV;
  }

  /** Tier thresholds + app metafield always use ×1000 (15 BHD → 15000). */
  function tierThresholdMinor(thresholdBhd) {
    var bhd = parseFloat(thresholdBhd != null ? thresholdBhd : 0) || 0;
    return Math.round(bhd * TIER_MINOR_DIV);
  }

  function legacyGiftThresholdMinor() {
    var cfg = window.MM_CART_SHEET_CONFIG || {};
    var raw = cfg.legacyGiftThreshold || cfg.giftThreshold;
    if (!raw) {
      var section = document.getElementById('mmPremiumGiftSection');
      raw = section && section.getAttribute('data-threshold');
    }
    var n = parseInt(raw, 10);
    if (!Number.isFinite(n) || n <= 0) return 0;
    var cd = shopMoneyDiv();
    if (cd === TIER_MINOR_DIV) return n;
    return Math.round((n * TIER_MINOR_DIV) / cd);
  }

  /** Convert cart.js line minor units → tier scale (×1000). */
  function toTierMinor(cartMinor) {
    var n = parseInt(cartMinor, 10) || 0;
    var cd = shopMoneyDiv();
    if (cd === TIER_MINOR_DIV) return n;
    return Math.round((n * TIER_MINOR_DIV) / cd);
  }

  function moneyDiv() {
    return TIER_MINOR_DIV;
  }

  function isAr() {
    var lang = (window.Shopify && window.Shopify.locale) || 'en';
    return String(lang).toLowerCase().indexOf('ar') === 0;
  }

  function jp(raw, fb) {
    if (O.jp) return O.jp(raw, fb);
    if (raw == null) return fb != null ? fb : {};
    if (typeof raw === 'object') return raw;
    try { return JSON.parse(raw || '{}'); } catch (e) { return fb != null ? fb : {}; }
  }

  function fmtMinorPlain(minor) {
    var amt = (minor / TIER_MINOR_DIV).toFixed(3);
    var c = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'BHD';
    if (isAr()) return amt + ' د.ب';
    return amt + ' ' + c;
  }

  function taxRate() {
    if (window.mmTaxConfig && window.mmTaxConfig.enabled && window.mmTaxConfig.rate) {
      return Number(window.mmTaxConfig.rate) || 1;
    }
    var cfg = window.MM_CART_SHEET_CONFIG;
    if (cfg && cfg.taxEnabled && cfg.taxRate) return Number(cfg.taxRate) || 1;
    return 1;
  }

  function applyTaxMinor(minor) {
    var rate = taxRate();
    if (rate <= 1) return minor;
    if (window.mmTaxConfig && typeof window.mmTaxConfig.applyTax === 'function') {
      return Math.round(window.mmTaxConfig.applyTax(minor));
    }
    return Math.round(minor * rate);
  }

  function lineTotalTaxed(item) {
    if (!item) return 0;
    var line = item.final_line_price != null
      ? item.final_line_price
      : (item.price || 0) * (item.quantity || 1);
    return applyTaxMinor(toTierMinor(line));
  }

  function fmtMinor(minor) {
    return fmtMinorPlain(minor);
  }

  function esc(s) {
    return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function cartApi(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.slice(-1) !== '/') root += '/';
    return root + String(path || '').replace(/^\//, '');
  }

  function cartPause(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms || 400);
    });
  }

  function isRateLimitError(err) {
    var status = err && (err.status || err.statusCode);
    if (status === 429 || status === 503) return true;
    var t = String((err && err.message) || '').toLowerCase();
    return t.indexOf('rate limit') !== -1 || t.indexOf('too many') !== -1;
  }

  function fetchJson(url, opts, attempt) {
    attempt = attempt || 0;
    opts = opts || {};
    var headers = Object.assign({ Accept: 'application/json' }, opts.headers || {});
    if (opts.headers) Object.assign(headers, opts.headers);
    return fetch(url, Object.assign({ credentials: 'same-origin' }, opts, { headers: headers }))
      .then(function (r) {
        return r.text().then(function (text) {
          var data = null;
          if (text) {
            try { data = JSON.parse(text); } catch (e) { data = null; }
          }
          if (data && typeof data === 'object') {
            if (!r.ok) {
              if ((r.status === 429 || r.status === 503) && attempt < 3) {
                return cartPause(1000 * Math.pow(2, attempt)).then(function () {
                  return fetchJson(url, opts, attempt + 1);
                });
              }
              var apiErr = new Error(data.description || data.message || ('cart api ' + r.status));
              apiErr.description = data.description;
              apiErr.status = data.status || r.status;
              throw apiErr;
            }
            return data;
          }
          if ((r.status === 429 || r.status === 503) && attempt < 3) {
            return cartPause(1000 * Math.pow(2, attempt)).then(function () {
              return fetchJson(url, opts, attempt + 1);
            });
          }
          var err = new Error('non-json response');
          err.status = r.status;
          throw err;
        });
      });
  }

  function cartVariantId(vid) {
    var n = normalizeVariantId(vid);
    if (n == null || n === '') return null;
    var num = parseInt(n, 10);
    return Number.isFinite(num) ? num : n;
  }

  function fetchCart() {
    if (window.MMCart && typeof window.MMCart.fetchCart === 'function') {
      return window.MMCart.fetchCart().then(normalizeCart);
    }
    return fetchJson(cartApi('cart.js')).then(normalizeCart);
  }

  function normalizeCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return cart;
    var items = cart.items.filter(function (it) { return (it.quantity || 0) > 0; });
    if (items.length === cart.items.length) return cart;
    var count = items.reduce(function (s, it) { return s + (it.quantity || 0); }, 0);
    return Object.assign({}, cart, { items: items, item_count: count });
  }

  var giftOpChain = Promise.resolve();
  var lastClaimAt = 0;

  function resetGiftOpChain() {
    giftOpChain = Promise.resolve();
  }

  function withGiftTimeout(promise, ms) {
    return Promise.race([
      promise,
      new Promise(function (_, reject) {
        setTimeout(function () { reject(new Error('gift op timeout')); }, ms || 45000);
      })
    ]);
  }

  function enqueueGiftOp(fn, opts) {
    opts = opts || {};
    var timeoutMs = opts.timeoutMs || 45000;
    var job = giftOpChain.then(function () {
      var idle = opts.skipIdleWait
        ? Promise.resolve()
        : waitForCartIdle(opts.idleMs || 4000);
      return withGiftTimeout(
        idle.then(function () { return runCartOps(fn); }),
        timeoutMs
      );
    });
    giftOpChain = job.catch(function () {});
    return job;
  }

  function removeGiftLines(cart) {
    var gifts = (cart.items || []).filter(isGiftLine);
    if (!gifts.length) return Promise.resolve(cart);
    var updates = {};
    gifts.forEach(function (g) {
      updates[g.key] = 0;
    });
    return fetchJson(cartApi('cart/update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(normalizeCart);
  }

  function mapGiftRows(raw) {
    if (!Array.isArray(raw)) return [];
    return raw.map(function (g) {
      if (!g) return null;
      var vid = g.variantId != null ? g.variantId : (g.variant_id != null ? g.variant_id : g.id);
      if (vid == null || vid === '') return null;
      return {
        variantId: vid,
        title: g.title || g.name || '',
        variant: g.variant || g.variantTitle || '',
        image: g.image || g.imageUrl || ''
      };
    }).filter(Boolean);
  }

  function tierChoiceGifts(tier) {
    if (!tier) return [];
    if (tier.choiceGifts && tier.choiceGifts.length) return tier.choiceGifts;
    return tier.gifts || [];
  }

  function tierMandatoryGifts(tier) {
    return (tier && tier.mandatoryGifts) || [];
  }

  function tierCatalogGifts(tier) {
    var seen = {};
    var out = [];
    tierChoiceGifts(tier).concat(tierMandatoryGifts(tier)).forEach(function (g) {
      var id = String(normalizeVariantId(g.variantId));
      if (!id || seen[id]) return;
      seen[id] = true;
      out.push(g);
    });
    return out;
  }

  function giftProps(tier, offerId, role) {
    var threshold = String(tierThresholdMinor(tier.thresholdBhd));
    var oid = String(offerId);
    return {
      _gift: 'true',
      _offerId: oid,
      _offerType: 'CART_TIER_GIFT',
      _tierThreshold: threshold,
      _gift_role: role || 'choice',
      mm_gift: 'true',
      mm_offer_id: oid,
      mm_offer_type: 'CART_TIER_GIFT',
      mm_tier_threshold: threshold,
      _mm_country: O.marketCountry ? O.marketCountry() : 'BH'
    };
  }

  function addOneGiftLine(vid, tier, offerId, role) {
    var id = cartVariantId(vid);
    if (!id) return Promise.reject(new Error('invalid variant'));
    return fetchJson(cartApi('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: id,
          quantity: 1,
          properties: giftProps(tier, offerId, role)
        }]
      })
    });
  }

  function isStockCartError(err) {
    var t = String((err && err.description) || (err && err.message) || '').toLowerCase();
    return /sold out|unavailable|not available|out of stock|already sold|enough inventory|inventory|نفد|غير متوفر|لا تتوفر/.test(t);
  }

  function fetchVariantAvailable(vid) {
    var id = cartVariantId(vid);
    if (!id) return Promise.resolve(false);
    return fetch(cartApi('variants/' + id + '.js'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (v) { return !!(v && v.available !== false); })
      .catch(function () { return true; });
  }

  function checkGiftsAvailable(variantIds) {
    var ids = (variantIds || []).filter(function (v) { return cartVariantId(v); });
    if (!ids.length) return Promise.resolve();
    return Promise.all(ids.map(function (vid) {
      return fetchVariantAvailable(vid).then(function (ok) {
        return { vid: vid, ok: ok };
      });
    })).then(function (results) {
      var bad = results.filter(function (r) { return !r.ok; });
      if (!bad.length) return;
      var err = new Error('sold out');
      err.description = isAr()
        ? 'الهدية غير متوفرة حالياً (نفدت الكمية)'
        : 'This gift is out of stock';
      throw err;
    });
  }

  function addTierGiftLinesOneByOne(variantIds, tier, offerId) {
    var choiceSet = {};
    tierChoiceGifts(tier).forEach(function (g) {
      choiceSet[String(normalizeVariantId(g.variantId))] = true;
    });
    return variantIds.reduce(function (chain, vid) {
      return chain.then(function () {
        var id = cartVariantId(vid);
        var role = choiceSet[String(id)] ? 'choice' : 'mandatory';
        return addOneGiftLine(vid, tier, offerId, role);
      });
    }, Promise.resolve());
  }

  function addTierGiftLinesBulk(variantIds, tier, offerId) {
    var choiceSet = {};
    tierChoiceGifts(tier).forEach(function (g) {
      choiceSet[String(normalizeVariantId(g.variantId))] = true;
    });
    var items = [];
    (variantIds || []).forEach(function (vid) {
      var id = cartVariantId(vid);
      if (!id) return;
      if (items.some(function (it) { return String(it.id) === String(id); })) return;
      var role = choiceSet[String(id)] ? 'choice' : 'mandatory';
      items.push({
        id: id,
        quantity: 1,
        properties: giftProps(tier, offerId, role)
      });
    });
    if (!items.length) return Promise.reject(new Error('invalid gift'));
    return fetchJson(cartApi('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    });
  }

  function clearGiftVariantLines(cart, variantIds) {
    var idSet = {};
    (variantIds || []).forEach(function (vid) {
      idSet[String(normalizeVariantId(vid))] = true;
    });
    var updates = {};
    (cart.items || []).forEach(function (it) {
      if (!isGiftLine(it)) return;
      if (idSet[String(it.variant_id)]) updates[it.key] = 0;
    });
    if (!Object.keys(updates).length) return Promise.resolve(cart);
    return fetchJson(cartApi('cart/update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(normalizeCart);
  }

  function verifyGiftLines(cart, variantIds) {
    var ids = variantIds || [];
    var missing = ids.filter(function (vid) {
      return !(cart.items || []).some(function (it) {
        return String(it.variant_id) === String(vid) && isGiftLine(it);
      });
    });
    if (!missing.length) return cart;
    throw new Error('gift add failed');
  }

  function addTierGiftLines(variantIds, tier, offerId) {
    var ids = [];
    (variantIds || []).forEach(function (vid) {
      var n = normalizeVariantId(vid);
      if (!n) return;
      if (ids.some(function (x) { return String(x) === String(n); })) return;
      ids.push(n);
    });
    if (!ids.length) return Promise.resolve();

    return addTierGiftLinesBulk(ids, tier, offerId)
      .catch(function (err) {
        if (isStockCartError(err) || isRateLimitError(err)) throw err;
        return addTierGiftLinesOneByOne(ids, tier, offerId);
      })
      .catch(function (err) {
        if (err && err.message === 'gift add failed') {
          var stockErr = new Error('sold out');
          stockErr.description = isAr()
            ? 'تعذر إضافة الهدية — قد تكون غير متوفرة'
            : 'Could not add gift — it may be out of stock';
          throw stockErr;
        }
        throw err;
      });
  }

  function releaseSheetUi() {
    var ov = document.getElementById('mmCartTierGiftOverlay');
    if (ov) {
      ov.classList.remove('is-open');
      ov.setAttribute('aria-hidden', 'true');
      ov.setAttribute('hidden', '');
    }
    state.popupOpen = false;
    state.pickerTier = null;
    state.loading = false;
    state.claimingGift = false;
    state.syncInFlight = false;
    setSheetBusy(false);
    var sheet = getCartSheetRoot();
    if (sheet && sheet.classList.contains('is-open')) {
      document.body.classList.add('mm-cart-sheet-open');
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }

  function setSheetBusy(on, message) {
    if (!window.MMCart) return;
    if (on && typeof window.MMCart.setSheetUpdating === 'function') {
      var cfg = window.MM_CART_SHEET_CONFIG || {};
      window.MMCart.setSheetUpdating(true, message || cfg.addingGift || cfg.updating);
      return;
    }
    if (typeof window.MMCart.clearSheetUpdating === 'function') {
      window.MMCart.clearSheetUpdating();
    } else if (typeof window.MMCart.setSheetUpdating === 'function') {
      window.MMCart.setSheetUpdating(false);
    }
  }

  function normalizeVariantId(vid) {
    var s = String(vid || '').trim();
    if (!s) return null;
    if (s.indexOf('gid://') >= 0) s = s.split('/').pop();
    var n = Number(s);
    return Number.isFinite(n) ? n : s;
  }

  function isBusy() {
    return !!state.claimingGift;
  }

  function isSyncing() {
    return !!(state.claimingGift || state.syncInFlight);
  }

  function onTierUnlocked(tierIdx, cart) {
    if (tierIdx < 0) return;
    if (tierIdx <= state.lastUnlockedTierIdx) return;

    var tier = state.tiers[tierIdx];
    if (!tier) return;

    state.lastUnlockedTierIdx = tierIdx;
    state.lastAutoClaimTierIdx = tierIdx - 1;

    /* First cart paint only seeds watermark — no popup spam on every page load */
    if (!state.unlockReady) return;

    state.popupPromptedTier = -1;
    try {
      var map = popupSeenStorage();
      delete map[popupSeenId(tier)];
      localStorage.setItem(POPUP_SEEN_KEY, JSON.stringify(map));
    } catch (e) {}

    requestAnimationFrame(function () {
      if (isBusy()) return;
      if (isGiftOptedOut(tier)) return;
      cart = normalizeCart(cart || getCartSnapshot() || { items: [] });
      if (!tierChoiceGifts(tier).length && tierMandatoryGifts(tier).length) {
        if (!hasGiftsForTier(cart, tier)) {
          claimGift(null, tier).catch(function () {});
        }
        return;
      }
      if (needsGiftPicker(cart, tierIdx)) {
        maybeAutoOpenGiftPopup(cart, tierIdx, { allowPopup: true });
      }
    });
  }

  function giftShouldStay(cart, gift) {
    var total = qualifyingTotal(cart);
    if (total <= 0) return false;

    var giftThreshold = giftTierThresholdFromLine(gift);
    if (giftThreshold == null) {
      var legacyThreshold = legacyGiftThresholdMinor();
      return legacyThreshold > 0 && total >= legacyThreshold;
    }

    var curIdx = tierForTotal(total, state.tiers);
    if (curIdx < 0) return false;
    var giftTier = tierByThreshold(giftThreshold);
    if (giftTier && isGiftOptedOut(giftTier)) return false;
    if (total < giftThreshold) return false;

    var curTier = state.tiers[curIdx];
    if (giftThreshold !== curTier.thresholdMinor && state.autoReplaceGiftOnUpgrade) return false;
    return giftAllowedInTier(gift.variant_id, curTier);
  }

  function hasGiftsForTier(cart, tier) {
    if (!tier) return false;
    var threshold = tier.thresholdMinor;
    return (cart.items || []).some(function (it) {
      return isGiftLine(it) && giftTierThresholdFromLine(it) === threshold;
    });
  }

  function removeAllGiftLinesFromServer(cart) {
    if (cart && cart.items) {
      return removeGiftLines(cart);
    }
    return fetchCart().then(function (c) { return removeGiftLines(c); });
  }

  function listIneligibleGifts(cart) {
    return (cart.items || []).filter(function (item) {
      if (!isGiftLine(item)) return false;
      if (!giftShouldStay(cart, item)) return true;
      var th = giftTierThresholdFromLine(item);
      if (th == null) return false;
      var valid = state.tiers.some(function (t) { return t.thresholdMinor === th; });
      return !valid;
    });
  }

  function giftsOverQty(cart) {
    return (cart.items || []).filter(function (item) {
      return isGiftLine(item) && (item.quantity || 1) > 1;
    });
  }

  function applyGiftLineFixes(cart) {
    cart = normalizeCart(cart);
    var ineligible = listIneligibleGifts(cart);
    var overQty = giftsOverQty(cart);
    if (!ineligible.length && !overQty.length) {
      return Promise.resolve({ cart: cart, dirty: false });
    }
    var updates = {};
    ineligible.forEach(function (g) {
      updates[g.key] = 0;
    });
    overQty.forEach(function (g) {
      if (updates[g.key] === 0) return;
      updates[g.key] = 1;
    });
    return fetchJson(cartApi('cart/update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (result) {
      return { cart: normalizeCart(result), dirty: true };
    });
  }

  function syncGiftEligibility(cart) {
    if (state.claimingGift || (!state.offer && !legacyGiftThresholdMinor()) || (!state.tiers.length && !legacyGiftThresholdMinor())) {
      return Promise.resolve({ cart: cart, dirty: false });
    }
    cart = normalizeCart(cart);
    var ineligible = listIneligibleGifts(cart);
    var overQty = giftsOverQty(cart);

    if (!ineligible.length && !overQty.length) {
      return Promise.resolve({ cart: cart, dirty: false });
    }

    var hasOptedOutRemoval = ineligible.some(function (item) {
      var th = giftTierThresholdFromLine(item);
      var tier = th != null ? tierByThreshold(th) : null;
      return tier && isGiftOptedOut(tier);
    });

    if (
      window.MMCart &&
      typeof window.MMCart.hasPendingLineOps === 'function' &&
      window.MMCart.hasPendingLineOps() &&
      !hasOptedOutRemoval &&
      !overQty.length
    ) {
      return Promise.resolve({ cart: cart, dirty: false });
    }

    return enqueueGiftOp(function () {
      state.syncInFlight = true;
      return applyGiftLineFixes(cart);
    })
      .then(function (result) {
        return { cart: normalizeCart(result.cart || cart), dirty: !!result.dirty };
      })
      .finally(function () {
        state.syncInFlight = false;
      });
  }

  function maybeAutoClaimMandatory(cart, tierIdx) {
    if (tierIdx < 0 || isBusy()) return Promise.resolve(cart);
    var tier = state.tiers[tierIdx];
    if (!tier || isGiftOptedOut(tier)) return Promise.resolve(cart);
    if (tierIdx <= state.lastAutoClaimTierIdx) return Promise.resolve(cart);
    if (tierChoiceGifts(tier).length) return Promise.resolve(cart);
    if (!tierMandatoryGifts(tier).length) return Promise.resolve(cart);
    if (hasGiftsForTier(cart, tier)) {
      state.lastAutoClaimTierIdx = tierIdx;
      return Promise.resolve(cart);
    }
    return claimGift(null, tier).then(function () {
      state.lastAutoClaimTierIdx = tierIdx;
      return cart;
    }).catch(function () { return cart; });
  }

  function needsGiftPicker(cart, tierIdx) {
    if (tierIdx < 0) return false;
    var tier = state.tiers[tierIdx];
    if (!tier) return false;
    var choices = tierChoiceGifts(tier);
    if (!choices.length) return false;
    var threshold = tier.thresholdMinor;
    var picked = (cart.items || []).some(function (it) {
      if (!isGiftLine(it)) return false;
      if (giftTierThresholdFromLine(it) !== threshold) return false;
      return choices.some(function (g) {
        return variantIdsMatch(g.variantId, it.variant_id);
      });
    });
    return !picked;
  }

  function getCartSnapshot() {
    if (window.MMCart && typeof window.MMCart.getCart === 'function') {
      var c = window.MMCart.getCart();
      if (c && c.items) return c;
    }
    return null;
  }

  function waitForCartIdle() {
    if (window.MMCart && typeof window.MMCart.waitForCartIdle === 'function') {
      return window.MMCart.waitForCartIdle(8000);
    }
    return Promise.resolve();
  }

  function runCartOps(fn) {
    window.__mmTierGiftCartOps = true;
    var p;
    if (window.MMCart && typeof window.MMCart.runCartMutation === 'function') {
      p = window.MMCart.runCartMutation(fn);
    } else if (window.MMCart && typeof window.MMCart.runWithoutHook === 'function') {
      p = window.MMCart.runWithoutHook(fn);
    } else {
      p = Promise.resolve().then(fn);
    }
    return p.finally(function () {
      window.__mmTierGiftCartOps = false;
    });
  }

  function tierLabel(tier) {
    if (!tier) return '';
    if (isAr() && tier.labelAr) return tier.labelAr;
    return tier.labelEn || tier.label || '';
  }

  function parseTiers(offer) {
    var ds = jp(offer.displaySettings, {});
    state.giftMode = String(ds.giftMode || 'TIERS').toUpperCase() === 'SINGLE' ? 'SINGLE' : 'TIERS';
    state.autoReplaceGiftOnUpgrade = !!ds.autoReplaceGiftOnUpgrade;
    var tiers = ds.cartGiftTiers || [];
    if (!Array.isArray(tiers)) tiers = [];
    if (state.giftMode === 'SINGLE') tiers = tiers.slice(0, 1);
    return tiers
      .map(function (t, i) {
        var thresholdBhd = parseFloat(t.thresholdBhd != null ? t.thresholdBhd : t.threshold) || 0;
        var choiceGifts = mapGiftRows(t.choiceGifts);
        var mandatoryGifts = mapGiftRows(t.mandatoryGifts);
        var legacyGifts = mapGiftRows(t.gifts);
        if (!choiceGifts.length && legacyGifts.length) choiceGifts = legacyGifts;
        return {
          index: i,
          thresholdBhd: thresholdBhd,
          thresholdMinor: tierThresholdMinor(thresholdBhd),
          labelEn: t.labelEn || t.label || '',
          labelAr: t.labelAr || '',
          choiceGifts: choiceGifts,
          mandatoryGifts: mandatoryGifts,
          gifts: choiceGifts.concat(mandatoryGifts)
        };
      })
      .filter(function (t) {
        return t.thresholdMinor > 0 && (t.choiceGifts.length > 0 || t.mandatoryGifts.length > 0);
      })
      .sort(function (a, b) { return a.thresholdMinor - b.thresholdMinor; });
  }

  function lineProps(item) {
    if (!item || item.properties == null) return {};
    if (typeof item.properties === 'object' && !Array.isArray(item.properties)) {
      return item.properties;
    }
    var out = {};
    if (Array.isArray(item.properties)) {
      item.properties.forEach(function (p) {
        if (!p) return;
        var k = p.name != null ? p.name : p.key;
        var v = p.value != null ? p.value : p.last;
        if (k != null && k !== '') out[k] = v;
      });
    }
    return out;
  }

  function propVal(item, key) {
    var props = lineProps(item);
    var v = props[key];
    if (v == null || v === '') {
      if (key === '_gift') v = props.mm_gift;
      else if (key === '_offerType') v = props.mm_offer_type;
      else if (key === '_offerId') v = props.mm_offer_id;
      else if (key === '_tierThreshold') v = props.mm_tier_threshold;
    }
    if (v == null) return '';
    return String(v);
  }

  function isGiftLine(item) {
    if (!item) return false;
    if (propVal(item, '_gift') === 'true') return true;
    if (propVal(item, '_offerType') === 'CART_TIER_GIFT') return true;
    if (propVal(item, 'mm_offer_type') === 'CART_TIER_GIFT') return true;
    return false;
  }

  function giftTierThresholdFromLine(gift) {
    if (!gift) return null;
    var raw = propVal(gift, '_tierThreshold');
    if (raw === '') return null;
    var n = parseInt(raw, 10);
    return Number.isFinite(n) && n > 0 ? n : null;
  }

  function tierByThreshold(thresholdMinor) {
    for (var i = 0; i < state.tiers.length; i++) {
      if (state.tiers[i].thresholdMinor === thresholdMinor) return state.tiers[i];
    }
    return null;
  }

  function tierForGiftLine(gift, totalMinor) {
    if (!gift) return null;
    var stored = giftTierThresholdFromLine(gift);
    if (stored != null) {
      var tier = tierByThreshold(stored);
      if (tier && totalMinor >= tier.thresholdMinor && giftAllowedInTier(gift.variant_id, tier)) return tier;
    }
    var vid = String(gift.variant_id || '');
    for (var i = state.tiers.length - 1; i >= 0; i--) {
      if (totalMinor >= state.tiers[i].thresholdMinor && giftAllowedInTier(vid, state.tiers[i])) {
        return state.tiers[i];
      }
    }
    return null;
  }

  function giftOptOutStorage() {
    try {
      var raw = sessionStorage.getItem(GIFT_OPT_OUT_KEY);
      return raw ? JSON.parse(raw) : {};
    } catch (e) {
      return {};
    }
  }

  function isGiftOptedOut(tier) {
    if (!tier) return false;
    var map = giftOptOutStorage();
    return !!map[popupSeenId(tier)];
  }

  function markGiftOptOut(tier) {
    if (!tier) return;
    var map = giftOptOutStorage();
    map[popupSeenId(tier)] = Date.now();
    try { sessionStorage.setItem(GIFT_OPT_OUT_KEY, JSON.stringify(map)); } catch (e) {}
  }

  function clearGiftOptOut(tier) {
    if (!tier) return;
    var map = giftOptOutStorage();
    delete map[popupSeenId(tier)];
    try { sessionStorage.setItem(GIFT_OPT_OUT_KEY, JSON.stringify(map)); } catch (e) {}
  }

  function onUserRemovedGift(item) {
    if (!item || !isGiftLine(item)) return;
    var th = giftTierThresholdFromLine(item);
    var tier = th != null ? tierByThreshold(th) : null;
    if (!tier) {
      var cart = getCartSnapshot() || { items: [] };
      var idx = tierForTotal(qualifyingTotal(cart), state.tiers);
      tier = idx >= 0 ? state.tiers[idx] : null;
    }
    if (tier) markGiftOptOut(tier);
    state.popupPromptedTier = -1;
    bumpSync();
  }

  function popupSeenStorage() {
    try {
      var raw = localStorage.getItem(POPUP_SEEN_KEY);
      if (!raw) {
        /* Migrate older session-only dismissals once */
        raw = sessionStorage.getItem(POPUP_SEEN_KEY);
        if (raw) {
          localStorage.setItem(POPUP_SEEN_KEY, raw);
          try { sessionStorage.removeItem(POPUP_SEEN_KEY); } catch (e2) {}
        }
      }
      return raw ? JSON.parse(raw) : {};
    } catch (e) {
      return {};
    }
  }

  function popupSeenId(tier) {
    return String((state.offer && state.offer.id) || '0') + ':' + (tier ? tier.thresholdMinor : '');
  }

  function isPopupDismissed(tier) {
    if (!tier) return true;
    var map = popupSeenStorage();
    return !!map[popupSeenId(tier)];
  }

  function markPopupSeen(tier) {
    if (!tier) return;
    var map = popupSeenStorage();
    map[popupSeenId(tier)] = Date.now();
    try { localStorage.setItem(POPUP_SEEN_KEY, JSON.stringify(map)); } catch (e) {}
  }

  function bootstrapTierIndex(cart) {
    if (state.tierBootstrapped || !state.tiers.length) return;
    state.tierBootstrapped = true;
    var total = qualifyingTotal(cart || { items: [] });
    var idx = tierForTotal(total, state.tiers);
    /* Seed unlock watermark so an already-reached tier does not re-open the popup on every load */
    if (idx >= 0) state.lastUnlockedTierIdx = idx;
    syncLastTierIndex(cart || { items: [] }, idx);
  }

  function qualifyingTotal(cart) {
    if (!cart) return 0;
    var total = 0;
    (cart.items || []).forEach(function (item) {
      if (!isGiftLine(item)) total += lineTotalTaxed(item);
    });
    return total;
  }

  function optimisticCartLine(cart, key, nextQty) {
    if (!cart || !cart.items) return cart;
    var items = [];
    var totalPrice = 0;
    cart.items.forEach(function (it) {
      if (it.key === key) {
        if (nextQty <= 0) return;
        var oldQ = it.quantity || 1;
        var line = it.final_line_price != null ? it.final_line_price : (it.price || 0) * oldQ;
        var unit = oldQ > 0 ? line / oldQ : (it.price || 0);
        var nextLine = Math.round(unit * nextQty);
        var nextItem = Object.assign({}, it, { quantity: nextQty, final_line_price: nextLine });
        items.push(nextItem);
        totalPrice += nextLine;
      } else {
        items.push(it);
        totalPrice += it.final_line_price != null ? it.final_line_price : (it.price || 0) * (it.quantity || 1);
      }
    });
    var count = items.reduce(function (s, it) { return s + (it.quantity || 0); }, 0);
    return Object.assign({}, cart, { items: items, item_count: count, total_price: totalPrice });
  }

  function cartSheetBusy() {
    return !!document.querySelector(
      '.mm-cart-sheet__item--updating, .mm-cart-sheet__qty--busy, .mm-cart-sheet__variant-picker.is-busy'
    );
  }

  function tierGiftSlots() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-mm-tier-gifts-slot]'));
  }

  function currentGiftLine(cart) {
    return (cart.items || []).find(isGiftLine) || null;
  }

  function tierForTotal(totalMinor, tiers) {
    var idx = -1;
    for (var i = 0; i < tiers.length; i++) {
      if (totalMinor >= tiers[i].thresholdMinor) idx = i;
    }
    return idx;
  }

  function nextTier(totalMinor, tiers) {
    for (var i = 0; i < tiers.length; i++) {
      if (totalMinor < tiers[i].thresholdMinor) return tiers[i];
    }
    return null;
  }

  function pickCartTierGiftOffer(offers) {
    return (offers || []).find(function (o) {
      return o && o.status === 'ACTIVE' && o.type === 'CART_TIER_GIFT';
    }) || null;
  }

  function applyOffersPayload(data) {
    if (!data) return false;
    state.settings = data.settings || {};
    var offer = pickCartTierGiftOffer(data.offers);
    if (!offer) {
      state.offer = null;
      state.tiers = [];
      return false;
    }
    state.offer = offer;
    state.tiers = parseTiers(offer);
    return state.tiers.length > 0;
  }

  function bootstrapFromCache() {
    if (window.__mmOffersBootstrap && applyOffersPayload(window.__mmOffersBootstrap)) return true;
    if (window.__mmPrefetch && typeof window.__mmPrefetch.readOffersSnapshot === 'function') {
      var snap = window.__mmPrefetch.readOffersSnapshot();
      if (snap && applyOffersPayload(snap)) return true;
    }
    return false;
  }

  function setGiftBarMessage(slot, text) {
    if (!slot) return;
    var giftMsg = slot.querySelector('[data-mm-gift-msg]');
    if (!giftMsg) return;
    giftMsg.removeAttribute('data-mm-gift-pending');
    giftMsg.textContent = text;
  }

  function showGiftBarInactive(msg) {
    tierGiftSlots().forEach(function (slot) {
      slot.hidden = true;
      slot.setAttribute('aria-hidden', 'true');
    });
  }

  function loadOffer() {
    if (state.offer && state.tiers.length) return Promise.resolve(state.offer);

    function finish(data) {
      if (data) applyOffersPayload(data);
      return state.offer;
    }

    var loader;
    if (window.__mmPrefetch && typeof window.__mmPrefetch.fetchOffers === 'function') {
      loader = window.__mmPrefetch.fetchOffers().then(finish);
    } else {
      var url = window.MMOffers && window.MMOffers.offersApiUrl ? window.MMOffers.offersApiUrl() : '/apps/mm-app/api/offers';
      loader = fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : { offers: [] }; })
        .then(finish);
    }

    var timeout = new Promise(function (_, reject) {
      setTimeout(function () { reject(new Error('offer load timeout')); }, 12000);
    });

    return Promise.race([loader, timeout]).catch(function (err) {
      console.warn('[MM Cart Tier Gifts] loadOffer failed:', err);
      bootstrapFromCache();
      return state.offer;
    });
  }

  function variantIdsMatch(a, b) {
    if (a == null || b == null) return false;
    return String(normalizeVariantId(a)) === String(normalizeVariantId(b));
  }

  function isCartPage() {
    return !!document.querySelector('.mm-cart-section, .mm-cart');
  }

  /**
   * Progress notices are routed through here too, so they must not be painted
   * as failures. Anything that is not a real error is flagged with `info`.
   */
  function notifyGiftInfo(message) {
    notifyGiftError({ message: message, __mmInfo: true });
  }

  function notifyGiftError(err) {
    var isInfo = !!(err && err.__mmInfo);
    var msg = isAr() ? 'تعذر إضافة الهدية. حاول مرة أخرى.' : 'Could not add gift. Please try again.';
    if (isInfo) {
      msg = String(err.message || '');
    } else if (err && err.message === 'below tier threshold') {
      msg = isAr() ? 'لم تصل بعد للحد المطلوب للهدية' : 'You have not reached the gift threshold yet';
    } else if (err && err.message === 'gift op timeout') {
      msg = isAr() ? 'انتهت مهلة تحديث الهدية. حدّث الصفحة وحاول مجدداً.' : 'Gift update timed out. Refresh and try again.';
    } else if (err && err.message === 'gift add failed') {
      msg = isAr() ? 'تعذّرت إضافة الهدية. حدّث الصفحة وحاول مجدداً.' : 'Could not add gift. Refresh and try again.';
    } else if (err && err.message === 'variant not in tier') {
      msg = isAr() ? 'هذه الهدية غير متاحة لهذا المستوى' : 'This gift is not available for your tier';
    } else if (isRateLimitError(err) || (err && err.status === 429)) {
      msg = isAr()
        ? 'السلة مشغولة — انتظر بضع ثوانٍ وحاول مجدداً'
        : 'Cart is busy — wait a few seconds and try again';
    } else if (isStockCartError(err)) {
      msg = err.description || (isAr() ? 'الهدية غير متوفرة حالياً' : 'This gift is out of stock');
    } else if (err && err.message === 'non-json response') {
      msg = isAr()
        ? ('خطأ في الاتصال بالسلة' + (err.status ? ' (' + err.status + ')' : '') + '. حدّث الصفحة وحاول مجدداً.')
        : ('Cart connection error' + (err.status ? ' (' + err.status + ')' : '') + '. Refresh and try again.');
    } else if (err && err.description) {
      msg = String(err.description);
    } else if (err && err.message && err.message !== 'invalid gift') {
      msg = String(err.message);
    }
    if (!msg) return;
    var toastType = isInfo ? '' : 'error';
    if (typeof window.mmShowToast === 'function') {
      window.mmShowToast(msg, toastType);
    } else if (window.MMCart && typeof window.MMCart.showToast === 'function') {
      window.MMCart.showToast(msg, toastType);
    } else if (!isInfo) {
      console.warn('[MM Cart Tier Gifts]', msg, err);
    }
  }

  function publishCart(cart, opts) {
    opts = opts || {};
    cart = normalizeCart(cart);
    if (
      window.MMCart &&
      typeof window.MMCart.hasPendingLineOps === 'function' &&
      window.MMCart.hasPendingLineOps()
    ) {
      return Promise.resolve(cart);
    }
    if (window.MMCart && typeof window.MMCart.applyUpdate === 'function') {
      window.MMCart.applyUpdate(cart, { loadRecs: false, fromTierGift: true });
      return Promise.resolve(cart);
    }
    if (isCartPage() && window.MMCartPage && typeof window.MMCartPage.applyUpdate === 'function') {
      return window.MMCartPage.applyUpdate(cart, {
        reloadSection: opts.reloadSection === true
      }).then(function () { return cart; });
    }
    return Promise.resolve(cart);
  }

  function claimGift(variantId, tier) {
    var normalizedId = variantId != null ? normalizeVariantId(variantId) : null;
    var choices = tierChoiceGifts(tier);
    var mandatory = tierMandatoryGifts(tier);

    if (state.claimingGift || !state.offer || !tier) {
      if (state.claimingGift) {
        notifyGiftInfo(isAr() ? 'جاري تحديث الهدية…' : 'Gift update in progress…');
      }
      return Promise.reject(new Error('invalid gift'));
    }
    if (choices.length && !normalizedId) {
      return Promise.reject(new Error('invalid gift'));
    }
    if (!choices.length && !mandatory.length) {
      return Promise.reject(new Error('invalid gift'));
    }
    if (!normalizedId && isGiftOptedOut(tier)) {
      return Promise.reject(new Error('gift declined'));
    }
    if (normalizedId && choices.length && !giftAllowedInChoice(normalizedId, tier)) {
      return Promise.reject(new Error('variant not in tier'));
    }

    var toAdd = mandatory.map(function (g) { return normalizeVariantId(g.variantId); }).filter(Boolean);
    if (normalizedId) {
      var dup = toAdd.some(function (vid) { return String(vid) === String(normalizedId); });
      if (!dup) toAdd.push(normalizedId);
    }

    state.loading = true;
    state.claimingGift = true;
    state.syncInFlight = false;
    bumpSync();
    resetGiftOpChain();
    var offerId = state.offer.id;
    var safetyTimer = setTimeout(function () {
      resetGiftOpChain();
      releaseSheetUi();
    }, 50000);

    return enqueueGiftOp(function () {
      setSheetBusy(true, isAr() ? 'جاري إضافة الهدية…' : 'Adding gift…');
      var claimIds = toAdd.slice();
      return fetchCart()
        .then(function (cart) {
          if (qualifyingTotal(cart) < tier.thresholdMinor) throw new Error('below tier threshold');
          var gifts = (cart.items || []).filter(isGiftLine);
          if (!gifts.length) return cart;
          return removeGiftLines(cart);
        })
        .then(function () {
          if (!claimIds.length) return null;
          return addTierGiftLines(claimIds, tier, offerId);
        })
        .then(fetchCart)
        .then(function (cart) {
          if (claimIds.length) verifyGiftLines(cart, claimIds);
          lastClaimAt = Date.now();
          clearGiftOptOut(tier);
          markPopupSeen(tier);
          state.popupPromptedTier = -1;
          var idx = tierForTotal(qualifyingTotal(cart), state.tiers);
          state.lastSyncedTierIdx = idx;
          state.lastAutoClaimTierIdx = idx;
          syncLastTierIndex(cart, idx);
          return publishCart(cart);
        })
        .catch(function (err) {
          return fetchCart()
            .then(function (live) { return publishCart(live); })
            .then(function () { throw err; });
        });
    }, { timeoutMs: 45000, skipIdleWait: true })
      .catch(function (err) {
        console.warn('[MM Cart Tier Gifts] claim failed:', err);
        resetGiftOpChain();
        notifyGiftError(err);
        return Promise.reject(err);
      })
      .finally(function () {
        clearTimeout(safetyTimer);
        releaseSheetUi();
        var cart = getCartSnapshot();
        if (cart) {
          try { updateUI(cart); } catch (e) {}
        }
      });
  }

  function giftAllowedInChoice(variantId, tier) {
    if (!tier || !variantId) return false;
    return tierChoiceGifts(tier).some(function (g) {
      return g && variantIdsMatch(g.variantId, variantId);
    });
  }

  function giftAllowedInTier(variantId, tier) {
    if (!tier || !variantId) return false;
    return tierCatalogGifts(tier).some(function (g) {
      return g && variantIdsMatch(g.variantId, variantId);
    });
  }

  function gridColsClass(count) {
    if (count <= 1) return 'mm-ctg-modal__grid--1';
    if (count <= 4) return 'mm-ctg-modal__grid--2';
    return 'mm-ctg-modal__grid--3';
  }

  function giftCardHtml(g, ar) {
    var title = g.productTitle || g.title || '';
    var variant = g.productTitle && g.title && g.title !== g.productTitle ? g.title : '';
    return '<button type="button" class="mm-ctg-gift-card" data-mm-ctg-pick="' + esc(normalizeVariantId(g.variantId)) + '">' +
      '<span class="mm-ctg-gift-card__free">' + esc(ar ? 'مجاني' : 'FREE') + '</span>' +
      '<div class="mm-ctg-gift-card__img-wrap">' +
        (g.image
          ? '<img src="' + esc(g.image) + '" alt="" class="mm-ctg-gift-card__img" loading="lazy">'
          : '<div class="mm-ctg-gift-card__ph"></div>') +
      '</div>' +
      '<span class="mm-ctg-gift-card__name">' + esc(title) + '</span>' +
      (variant ? '<span class="mm-ctg-gift-card__variant">' + esc(variant) + '</span>' : '') +
      '<span class="mm-ctg-gift-card__pick">' + esc(ar ? 'اختيار' : 'Select') + '</span>' +
    '</button>';
  }

  function mandatoryGiftHtml(g, ar) {
    var title = g.productTitle || g.title || '';
    var variant = g.productTitle && g.title && g.title !== g.productTitle ? g.title : '';
    return '<div class="mm-ctg-fixed-gift">' +
      '<div class="mm-ctg-fixed-gift__img-wrap">' +
        (g.image
          ? '<img src="' + esc(g.image) + '" alt="" class="mm-ctg-fixed-gift__img" loading="lazy">'
          : '<div class="mm-ctg-fixed-gift__ph"></div>') +
      '</div>' +
      '<div class="mm-ctg-fixed-gift__body">' +
        '<span class="mm-ctg-fixed-gift__badge">' + esc(ar ? 'تضاف تلقائياً' : 'Auto-added') + '</span>' +
        '<span class="mm-ctg-fixed-gift__name">' + esc(title) + '</span>' +
        (variant ? '<span class="mm-ctg-fixed-gift__variant">' + esc(variant) + '</span>' : '') +
      '</div>' +
    '</div>';
  }

  function updateUI(cart) {
    if (!state.tiers.length) return null;
    try {
      var total = 0;
      var tierIdx = -1;
      if (cart && cart.items && cart.items.length) {
        total = qualifyingTotal(cart);
        tierIdx = tierForTotal(total, state.tiers);
      }
      if (tierIdx >= 0) onTierUnlocked(tierIdx, cart);
      state.lastUiTierIdx = tierIdx;
      state.lastUiTotal = total;
      tierGiftSlots().forEach(function (slot) {
        renderLadder(ensureLadderContainer(slot), total, tierIdx);
        updateIncentiveBar(slot, total, tierIdx, cart);
      });
      syncGiftFooterBtn(cart);
      return { total: total, tierIdx: tierIdx };
    } catch (err) {
      console.warn('[MM Cart Tier Gifts] updateUI failed:', err);
      showGiftBarInactive(isAr()
        ? 'تعذر عرض شريط الهدايا. حدّث الصفحة.'
        : 'Could not render gift bar. Refresh the page.');
      return null;
    }
  }

  function openPickerForCurrentTier(cart) {
    function pick(c) {
      var total = qualifyingTotal(c);
      var tierIdx = tierForTotal(total, state.tiers);
      if (tierIdx < 0) return false;
      var tier = state.tiers[tierIdx];
      if (!tier) return false;
      var choices = tierChoiceGifts(tier);
      var mandatory = tierMandatoryGifts(tier);
      if (!choices.length && mandatory.length) {
        clearGiftOptOut(tier);
        claimGift(null, tier).catch(function () {});
        return true;
      }
      if (!choices.length) return false;
      clearGiftOptOut(tier);
      state.popupPromptedTier = -1;
      openPopup(tier);
      return true;
    }
    cart = cart || getCartSnapshot();
    if (cart && cart.items) {
      return Promise.resolve(pick(cart));
    }
    return fetchCart().then(pick);
  }

  function canOpenGiftPicker(cart) {
    cart = cart || getCartSnapshot() || { items: [] };
    if (!state.tiers.length) return false;
    var total = qualifyingTotal(cart);
    var tierIdx = tierForTotal(total, state.tiers);
    if (tierIdx < 0) return false;
    var tier = state.tiers[tierIdx];
    if (!tier) return false;
    var choices = tierChoiceGifts(tier);
    var mandatory = tierMandatoryGifts(tier);
    return !!(choices.length || mandatory.length);
  }

  function openGiftOrDetails(cart) {
    cart = cart || getCartSnapshot();
    function openDetails() {
      var details = document.querySelector('#mm-cart-sheet .mm-cart-sheet__perk-more');
      if (details) {
        details.open = true;
        try {
          details.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        } catch (e) {}
      }
      return false;
    }
    if (!canOpenGiftPicker(cart)) return Promise.resolve(openDetails());
    return openPickerForCurrentTier(cart).then(function (opened) {
      if (opened) return true;
      return openDetails();
    });
  }

  function renderLadder(container, totalMinor, tierIdx) {
    if (!container || !state.tiers.length) {
      if (container) container.hidden = true;
      return;
    }
    container.hidden = false;
    var ar = isAr();
    var html = '<div class="mm-ctg-ladder">';
    state.tiers.forEach(function (tier, i) {
      var unlocked = totalMinor >= tier.thresholdMinor;
      var active = i === tierIdx;
      var gifts = tierCatalogGifts(tier);
      var rewardText = gifts.length
        ? gifts.slice(0, 2).map(function (g) { return g.productTitle || g.title || ''; }).filter(Boolean).join(ar ? ' + ' : ' + ')
        : (ar ? 'هدية مجانية' : 'Free gift');
      if (gifts.length > 2) rewardText += ar ? ' + المزيد' : ' + more';
      var cls = 'mm-ctg-step' + (unlocked ? ' is-unlocked' : '') + (active ? ' is-active' : '');
      html += '<div class="' + cls + '">' +
        '<div class="mm-ctg-step__dot">' + (unlocked ? '✓' : (i + 1)) + '</div>' +
        '<div class="mm-ctg-step__body">' +
          '<div class="mm-ctg-step__amt">' + esc(fmtMinor(tier.thresholdMinor)) + '</div>' +
          '<div class="mm-ctg-step__label">' + esc(tierLabel(tier) || ((ar ? 'هدية مستوى ' : 'Tier ') + (i + 1))) + '</div>' +
          '<div class="mm-ctg-step__reward">' + esc(rewardText) + '</div>' +
          '<div class="mm-ctg-step__gifts">' + gifts.slice(0, 3).map(function (g) {
            return g.image
              ? '<img src="' + esc(g.image) + '" alt="" class="mm-ctg-step__thumb">'
              : '';
          }).join('') + '</div>' +
        '</div></div>';
      if (i < state.tiers.length - 1) {
        html += '<div class="mm-ctg-step__line' + (unlocked ? ' is-unlocked' : '') + '"></div>';
      }
    });
    html += '</div>';
    container.innerHTML = html;
  }

  function updateIncentiveBar(slot, totalMinor, tierIdx, cart) {
    if (!slot) return;
    var giftEl = slot.querySelector('[data-mm-gift-bar]');
    var giftMsg = slot.querySelector('[data-mm-gift-msg]');
    var giftFill = slot.querySelector('[data-mm-gift-fill]');
    if (!giftEl || !giftMsg || !giftFill || !state.tiers.length) return;
    if (giftMsg.hasAttribute('data-mm-gift-pending')) giftMsg.removeAttribute('data-mm-gift-pending');

    cart = cart || getCartSnapshot() || { items: [] };
    var nt = nextTier(totalMinor, state.tiers);
    var ar = isAr();
    var curTier = tierIdx >= 0 ? state.tiers[tierIdx] : null;
    var prevThreshold = curTier ? curTier.thresholdMinor : 0;
    var currentChoices = curTier ? tierChoiceGifts(curTier) : [];
    var currentNeedsPick = needsGiftPicker(cart, tierIdx);
    var showChoose = tierIdx >= 0 && currentChoices.length > 0;

    if (nt) {
      var rem = Math.max(0, nt.thresholdMinor - totalMinor);
      var segRange = nt.thresholdMinor - prevThreshold;
      var segDone = Math.max(0, totalMinor - prevThreshold);
      giftFill.style.width = segRange > 0
        ? Math.min(100, Math.round((segDone * 100) / segRange)) + '%'
        : '0%';
      giftEl.classList.toggle('is-unlocked', tierIdx >= 0);
      if (isCartSheetSlot(slot)) {
        giftMsg.innerHTML =
          '<strong class="mm-cart-sheet__perk-amount">' +
          esc(fmtMinorPlain(rem)) +
          '</strong> <span class="mm-cart-sheet__perk-tail">' +
          esc(ar ? 'للهدية' : 'to gift') +
          '</span>';
        giftEl.setAttribute('title', ar
          ? ('أضف ' + fmtMinorPlain(rem) + ' للوصول إلى ' + (tierLabel(nt) || ('مستوى ' + (nt.index + 1))))
          : ('Add ' + fmtMinorPlain(rem) + ' to reach ' + (tierLabel(nt) || ('Tier ' + (nt.index + 1)))));
      } else {
        giftMsg.textContent = ar
          ? ('أضف ' + fmtMinorPlain(rem) + ' للوصول إلى ' + (tierLabel(nt) || ('مستوى ' + (nt.index + 1))))
          : ('Add ' + fmtMinorPlain(rem) + ' to reach ' + (tierLabel(nt) || ('Tier ' + (nt.index + 1))));
      }
    } else if (tierIdx >= 0) {
      giftEl.classList.add('is-unlocked');
      giftFill.style.width = '100%';
      if (isCartSheetSlot(slot)) {
        giftMsg.innerHTML =
          '<span class="mm-cart-sheet__perk-status">' +
          esc(currentNeedsPick ? (ar ? 'هدية جاهزة' : 'Gift ready') : (ar ? 'هدية مفعّلة' : 'Gift unlocked')) +
          '</span>';
        giftEl.setAttribute('title', ar ? 'اختر هديتك من الزر أسفل' : 'Choose your gift from the button below');
      } else {
        giftMsg.textContent = ar
          ? ('🎁 ' + (tierLabel(curTier) || 'أعلى مستوى') + ' — اختر هديتك')
          : ('🎁 ' + (tierLabel(curTier) || 'Top tier') + ' — choose your gift');
      }
    } else {
      giftEl.classList.remove('is-unlocked');
      giftFill.style.width = '0%';
      var first = state.tiers[0];
      var rem0 = first ? Math.max(0, first.thresholdMinor - totalMinor) : 0;
      if (isCartSheetSlot(slot)) {
        if (first) {
          giftMsg.innerHTML =
            '<strong class="mm-cart-sheet__perk-amount">' +
            esc(fmtMinorPlain(rem0)) +
            '</strong> <span class="mm-cart-sheet__perk-tail">' +
            esc(ar ? 'للهدية' : 'to gift') +
            '</span>';
        } else {
          giftMsg.innerHTML =
            '<span class="mm-cart-sheet__perk-status">' +
            esc(ar ? 'هدية' : 'Gift') +
            '</span>';
        }
      } else {
        giftMsg.textContent = first
          ? (ar
            ? ('أضف ' + fmtMinorPlain(rem0) + ' للوصول إلى ' + (tierLabel(first) || 'الهدية الأولى'))
            : ('Add ' + fmtMinorPlain(rem0) + ' to reach ' + (tierLabel(first) || 'first gift')))
          : (ar ? 'أضف منتجات للحصول على هدية' : 'Add items to unlock gifts');
      }
    }

    var btn = giftEl.querySelector('[data-mm-ctg-choose]');
    /* Cart sheet uses footer gift icon — skip bulky choose CTA */
    if (isCartSheetSlot(slot)) {
      if (btn) btn.hidden = true;
    } else if (showChoose) {
      if (!btn) {
        btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'mm-ctg-choose-btn';
        btn.setAttribute('data-mm-ctg-choose', '1');
        btn.textContent = currentNeedsPick
          ? (ar ? 'اختر الهدية' : 'Choose gift')
          : (ar ? 'تغيير الهدية' : 'Change gift');
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          openPickerForCurrentTier(getCartSnapshot());
        });
        giftEl.appendChild(btn);
      } else {
        btn.textContent = currentNeedsPick
          ? (ar ? 'اختر الهدية' : 'Choose gift')
          : (ar ? 'تغيير الهدية' : 'Change gift');
      }
      btn.hidden = false;
      btn.disabled = isBusy();
      btn.classList.toggle('is-loading', isBusy());
    } else if (btn) {
      btn.hidden = true;
      btn.disabled = false;
      btn.classList.remove('is-loading');
    }

    syncGiftCodeNotice(slot, cart, tierIdx);
  }

  function isCartSheetSlot(slot) {
    return !!(
      slot &&
      (slot.id === 'mmCartSheetIncentives' ||
        slot.id === 'mmCartV2Progress' ||
        slot.closest('#mm-cart-sheet') ||
        slot.closest('#mm-cart-drawer-v2'))
    );
  }

  function ensureLadderContainer(slot) {
    if (!slot) return null;
    var el = slot.querySelector('[data-mm-tier-ladder]');
    if (!el) {
      el = document.createElement('div');
      el.setAttribute('data-mm-tier-ladder', '1');
      el.className = 'mm-ctg-ladder-wrap';
      var details = slot.querySelector('[data-mm-perk-details]');
      if (details) {
        details.appendChild(el);
      } else {
        var giftEl = slot.querySelector('[data-mm-gift-bar]');
        if (giftEl && giftEl.parentNode) giftEl.parentNode.insertBefore(el, giftEl.nextSibling);
        else slot.appendChild(el);
      }
    }
    return el;
  }

  function popupMount() {
    return getCartSheetRoot() || document.body;
  }

  function buildPopup() {
    var ov = document.getElementById('mmCartTierGiftOverlay');
    if (ov) return ov;
    ov = document.createElement('div');
    ov.id = 'mmCartTierGiftOverlay';
    ov.className = 'mm-ctg-overlay';
    ov.setAttribute('hidden', '');
    ov.setAttribute('aria-hidden', 'true');
    ov.innerHTML = '<div class="mm-ctg-modal" role="dialog" aria-modal="true">' +
      '<button type="button" class="mm-ctg-modal__close" data-mm-ctg-close aria-label="Close">&times;</button>' +
      '<div class="mm-ctg-modal__head"></div>' +
      '<div class="mm-ctg-modal__body"><div class="mm-ctg-modal__grid"></div></div>' +
      '<div class="mm-ctg-modal__foot"><button type="button" class="mm-ctg-modal__later" data-mm-ctg-close>' +
      esc(isAr() ? 'ليس الآن' : 'Not now') +
      '</button></div>' +
    '</div>';
    popupMount().appendChild(ov);
    wirePopupClose(ov);
    wirePopupPick(ov);
    return ov;
  }

  function wirePopupClose(ov) {
    if (!ov || ov.dataset.mmCtgCloseWired === '1') return;
    ov.dataset.mmCtgCloseWired = '1';
    ov.addEventListener('click', function (e) {
      if (e.target === ov) closePopup(true);
    });
    ov.addEventListener('click', function (e) {
      if (e.target.closest('[data-mm-ctg-close]')) {
        e.preventDefault();
        e.stopPropagation();
        closePopup(true);
      }
    }, true);
    ov.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mm-ctg-remove-discount]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var code = btn.getAttribute('data-mm-ctg-remove-discount');
      if (!code) return;
      btn.disabled = true;
      removeDiscountCode(code)
        .then(function () {
          if (state.pickerTier) openPopup(state.pickerTier);
        })
        .catch(function () {
          btn.disabled = false;
        });
    }, true);
  }

  function wirePopupPick(ov) {
    if (!ov || ov.dataset.mmCtgPickWired === '1') return;
    ov.dataset.mmCtgPickWired = '1';
    ov.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mm-ctg-pick]');
      if (!btn || btn.disabled || btn.classList.contains('is-loading')) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      var vid = btn.getAttribute('data-mm-ctg-pick');
      var tier = state.pickerTier;
      if (!vid || !tier) return;
      if (state.claimingGift) {
        notifyGiftInfo(isAr() ? 'جاري تحديث الهدية…' : 'Gift update in progress…');
        return;
      }
      btn.disabled = true;
      btn.classList.add('is-loading');
      var pickedTier = tier;
      clearGiftOptOut(pickedTier);
      var ovNow = document.getElementById('mmCartTierGiftOverlay');
      if (ovNow) {
        ovNow.classList.remove('is-open');
        ovNow.setAttribute('hidden', '');
        ovNow.setAttribute('aria-hidden', 'true');
      }
      state.popupOpen = false;
      state.pickerTier = null;
      claimGift(vid, pickedTier).catch(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
    }, true);
  }

  function attachPopupToSheet(ov) {
    var sheet = getCartSheetRoot();
    if (!ov) return;
    if (sheet) {
      if (ov.parentNode !== sheet) sheet.appendChild(ov);
      ov.classList.add('mm-ctg-overlay--in-sheet');
    } else {
      ov.classList.remove('mm-ctg-overlay--in-sheet');
      if (ov.parentNode !== document.body) document.body.appendChild(ov);
    }
  }

  function giftDiscountNoticeCopy() {
    var messages = window.MM_COMPAT_I18N || {};
    return {
      rule: messages.gift_discount_rule || (isAr()
        ? 'الهدية مجانية فقط بدون كود خصم.'
        : 'Free gift only works without a discount code.'),
      blocked: messages.gift_discount_blocked || (isAr()
        ? 'كود الخصم يمنع الهدية المجانية.'
        : 'A discount code blocks the free gift.'),
      hint: messages.gift_discount_action_hint || (isAr()
        ? 'أزل الكود أدناه لتفعيل الهدية.'
        : 'Remove the code below to activate the gift.'),
      remove: messages.gift_discount_remove_code || (isAr() ? 'أزل الكود' : 'Remove code')
    };
  }

  function cartDiscountCodesLocal(cart) {
    if (window.MMCart && typeof window.MMCart.cartDiscountCodes === 'function') {
      return window.MMCart.cartDiscountCodes(cart) || [];
    }
    var codes = [];
    ((cart && cart.discount_codes) || []).forEach(function (discount) {
      if (discount && discount.applicable !== false && discount.code) codes.push(discount.code);
    });
    ((cart && cart.cart_level_discount_applications) || []).forEach(function (discount) {
      if (discount && discount.type === 'discount_code' && discount.title) codes.push(discount.title);
    });
    return codes.filter(function (code, index, list) {
      var normalized = String(code || '').trim().toLowerCase();
      return normalized && list.findIndex(function (candidate) {
        return String(candidate || '').trim().toLowerCase() === normalized;
      }) === index;
    });
  }

  function giftDiscountNoticeHtml(cart, opts) {
    opts = opts || {};
    var copy = giftDiscountNoticeCopy();
    var codes = cartDiscountCodesLocal(cart);
    var blocked = codes.length > 0;
    var compact = !!opts.compact;
    var html = '<div class="mm-ctg-gift-code-notice' + (blocked ? ' is-blocked' : '') + '" role="status">';
    html += '<div class="mm-ctg-gift-code-notice__icon" aria-hidden="true">' + (blocked ? '⚠️' : '🎁') + '</div>';
    html += '<div class="mm-ctg-gift-code-notice__body">';
    html += '<p class="mm-ctg-gift-code-notice__title">' + esc(blocked ? copy.blocked : copy.rule) + '</p>';
    if (blocked) {
      html += '<p class="mm-ctg-gift-code-notice__hint">' + esc(copy.hint) + '</p>';
      html += '<div class="mm-ctg-gift-code-notice__actions">';
      codes.forEach(function (code) {
        html +=
          '<button type="button" class="mm-ctg-gift-code-notice__remove" data-mm-ctg-remove-discount="' +
          esc(code) +
          '">' +
          esc(copy.remove) +
          ' · ' +
          esc(code) +
          '</button>';
      });
      html += '</div>';
    }
    html += '</div></div>';
    return html;
  }

  function ensureGiftCodeNoticeHost(slot) {
    if (!slot) return null;
    var host = slot.querySelector('[data-mm-gift-code-notice]');
    if (host) return host;
    host = document.createElement('div');
    host.setAttribute('data-mm-gift-code-notice', '');
    host.hidden = true;
    var giftEl = slot.querySelector('[data-mm-gift-bar]');
    if (giftEl && giftEl.parentNode) giftEl.parentNode.insertBefore(host, giftEl.nextSibling);
    else slot.appendChild(host);
    return host;
  }

  function syncGiftCodeNotice(slot, cart, tierIdx) {
    var host = ensureGiftCodeNoticeHost(slot);
    if (!host) return;
    cart = cart || getCartSnapshot() || { items: [] };
    var hasGift = (cart.items || []).some(isGiftLine);
    var unlocked = typeof tierIdx === 'number' ? tierIdx >= 0 : false;
    if (!hasGift && !unlocked) {
      host.hidden = true;
      host.innerHTML = '';
      return;
    }
    host.innerHTML = giftDiscountNoticeHtml(cart, { compact: true });
    host.hidden = false;
  }

  function removeDiscountCode(code) {
    if (window.MMCart && typeof window.MMCart.removeDiscount === 'function') {
      return Promise.resolve(window.MMCart.removeDiscount(code));
    }
    if (typeof window.mmRemoveDiscount === 'function') {
      window.mmRemoveDiscount(code);
      return Promise.resolve();
    }
    var target = String(code || '').trim().toLowerCase();
    return fetchCart().then(function (cart) {
      var remaining = cartDiscountCodesLocal(cart).filter(function (candidate) {
        return String(candidate || '').trim().toLowerCase() !== target;
      });
      return fetch(window.Shopify && Shopify.routes && Shopify.routes.root
        ? Shopify.routes.root + 'cart/update.js'
        : '/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: remaining.join(',') })
      }).then(function (r) {
        if (!r.ok) throw new Error('discount remove failed');
        return r.json();
      }).then(function (nextCart) {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: nextCart } }));
        if (window.MMCart && typeof window.MMCart.applyUpdate === 'function') {
          window.MMCart.applyUpdate(nextCart);
        } else if (window.location && /\/cart/.test(window.location.pathname)) {
          window.location.reload();
        }
        return nextCart;
      });
    });
  }

  function openPopup(tier) {
    var choices = tierChoiceGifts(tier);
    if (!tier || !choices.length) return;
    state.pickerTier = tier;
    var ov = buildPopup();
    attachPopupToSheet(ov);
    var ar = isAr();
    var head = ov.querySelector('.mm-ctg-modal__head');
    var grid = ov.querySelector('.mm-ctg-modal__grid');
    var later = ov.querySelector('.mm-ctg-modal__later');
    var mandatory = tierMandatoryGifts(tier);
    if (head) {
      head.innerHTML =
        '<div class="mm-ctg-modal__badge">🎁 ' + esc(fmtMinor(tier.thresholdMinor)) + '</div>' +
        '<h3 class="mm-ctg-modal__title">' + esc(tierLabel(tier) || (ar ? 'اختر هديتك المجانية' : 'Choose your free gift')) + '</h3>' +
        '<p class="mm-ctg-modal__sub">' + esc(ar
          ? ('اختر هدية واحدة من ' + choices.length + ' خيار' + (choices.length > 1 ? 'ات' : ''))
          : ('Pick one of ' + choices.length + ' free gift' + (choices.length > 1 ? 's' : ''))) +
          (mandatory.length
            ? (ar ? ' + هدية إضافية ثابتة تظهر مع اختيارك' : ' + fixed bonus gift added with your choice')
            : '') +
          '</p>' +
          giftDiscountNoticeHtml(getCartSnapshot() || { items: [] });
    }
    if (grid) {
      grid.className = 'mm-ctg-modal__grid ' + gridColsClass(choices.length);
      grid.innerHTML =
        (mandatory.length
          ? '<div class="mm-ctg-mandatory">' +
            '<div class="mm-ctg-mandatory__title">' + esc(ar ? 'هدية إضافية ثابتة مع هذا المستوى' : 'Fixed bonus gift in this tier') + '</div>' +
            '<div class="mm-ctg-mandatory__list">' + mandatory.map(function (g) { return mandatoryGiftHtml(g, ar); }).join('') + '</div>' +
            '</div>'
          : '') +
        '<div class="mm-ctg-choice-title">' + esc(ar ? 'اختر هديتك' : 'Choose your gift') + '</div>' +
        choices.map(function (g) {
          return giftCardHtml(g, ar);
        }).join('');
    }
    if (later) {
      var hasOldTierGift = (getCartSnapshot() || { items: [] }).items.some(function (it) {
        return isGiftLine(it) && giftTierThresholdFromLine(it) !== tier.thresholdMinor;
      });
      later.textContent = hasOldTierGift
        ? (ar ? 'لاحقاً' : 'Not now')
        : (ar ? 'لاحقاً — أبقِ هديتي الحالية' : 'Not now — keep my current gift');
    }
    ov.classList.add('is-open');
    ov.removeAttribute('hidden');
    ov.setAttribute('aria-hidden', 'false');
    state.popupOpen = true;
    var sheetOpen = getCartSheetRoot();
    if (!sheetOpen || !sheetOpen.classList.contains('is-open')) {
      document.body.style.overflow = 'hidden';
    }
  }

  function closePopup(markSeen) {
    var tier = state.pickerTier;
    var ov = document.getElementById('mmCartTierGiftOverlay');
    if (ov) {
      ov.classList.remove('is-open');
      ov.setAttribute('hidden', '');
      ov.setAttribute('aria-hidden', 'true');
    }
    state.popupOpen = false;
    state.pickerTier = null;
    if (markSeen && tier) markPopupSeen(tier);
    var sheet = getCartSheetRoot();
    if (sheet && sheet.classList.contains('is-open')) {
      document.body.classList.add('mm-cart-sheet-open');
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }

  function shouldAutoPopup(cart, tierIdx) {
    if (tierIdx < 0 || state.popupOpen || isBusy()) return false;
    var tier = state.tiers[tierIdx];
    if (!tier || isGiftOptedOut(tier)) return false;
    var ds = jp(state.offer && state.offer.displaySettings, {});
    if (ds.showPopupOnUnlock === false) return false;
    if (!needsGiftPicker(cart, tierIdx)) return false;
    if (isPopupDismissed(tier)) return false;
    if (state.popupPromptedTier === tierIdx) return false;
    return true;
  }

  function maybeAutoOpenGiftPopup(cart, tierIdx, opts) {
    opts = opts || {};
    if (!opts.allowPopup || tierIdx < 0) return false;
    if (!shouldAutoPopup(cart, tierIdx)) return false;
    state.popupPromptedTier = tierIdx;
    /* Mark seen immediately so cart refreshes cannot re-spam the same unlock */
    markPopupSeen(state.tiers[tierIdx]);
    requestAnimationFrame(function () {
      if (!state.popupOpen && !isBusy()) openPopup(state.tiers[tierIdx]);
    });
    return true;
  }

  function bumpSync() {
    syncScheduleId++;
    if (syncTimer) {
      clearTimeout(syncTimer);
      syncTimer = null;
    }
  }

  function scheduleSync(cart) {
    if ((!state.tiers.length && !legacyGiftThresholdMinor()) || state.claimingGift) return;
    bumpSync();
    var myId = syncScheduleId;
    var delay = 220;
    if (
      window.MMCart &&
      typeof window.MMCart.getLastLineOpAt === 'function' &&
      Date.now() - window.MMCart.getLastLineOpAt() < 3500
    ) {
      delay = 750;
    }
    syncTimer = setTimeout(function () {
      if (myId !== syncScheduleId || state.claimingGift) return;
      if (window.MMCart && typeof window.MMCart.hasPendingLineOps === 'function' && window.MMCart.hasPendingLineOps()) {
        scheduleSync(getCartSnapshot() || cart);
        return;
      }
      var snapshot = normalizeCart(getCartSnapshot() || cart || { items: [], item_count: 0, total_price: 0 });
      runFullSync(snapshot, myId);
    }, delay);
  }

  function purgeIneligibleGifts(cart) {
    if ((!state.tiers.length && !legacyGiftThresholdMinor()) || state.claimingGift) {
      return Promise.resolve(cart || getCartSnapshot());
    }
    cart = normalizeCart(cart || getCartSnapshot() || { items: [], item_count: 0, total_price: 0 });
    if (!listIneligibleGifts(cart).length && !giftsOverQty(cart).length) {
      return Promise.resolve(cart);
    }
    if (window.MMCart && typeof window.MMCart.hasPendingLineOps === 'function' && window.MMCart.hasPendingLineOps()) {
      scheduleSync(cart);
      return Promise.resolve(cart);
    }
    return syncGiftEligibility(cart).then(function (result) {
      var synced = normalizeCart(result.cart || cart);
      updateUI(synced);
      if (result.dirty) {
        return publishCart(synced, { reloadSection: isCartPage() }).then(function () {
          updateUI(synced);
          syncLastTierIndex(synced, tierForTotal(qualifyingTotal(synced), state.tiers));
          return synced;
        });
      }
      return synced;
    });
  }

  function runFullSync(cart, syncId) {
    return syncGiftEligibility(cart).then(function (result) {
      if (syncId != null && syncId !== syncScheduleId) return result;
      var synced = normalizeCart(result.cart || cart);
      updateUI(synced);
      if (result.dirty) {
        if (
          window.MMCart &&
          typeof window.MMCart.hasPendingLineOps === 'function' &&
          window.MMCart.hasPendingLineOps()
        ) {
          syncLastTierIndex(synced, tierForTotal(qualifyingTotal(synced), state.tiers));
          return result;
        }
        return publishCart(synced, { reloadSection: isCartPage() }).then(function () {
          if (syncId != null && syncId !== syncScheduleId) return result;
          updateUI(synced);
          syncLastTierIndex(synced, tierForTotal(qualifyingTotal(synced), state.tiers));
          return result;
        });
      }
      if (uiTierFinish(synced)) return result;
      return result;
    });
  }

  function uiTierFinish(cart) {
    var ui = updateUI(cart);
    syncLastTierIndex(cart, ui ? ui.tierIdx : -1);
    if (ui && ui.tierIdx >= 0 && !isBusy()) {
      maybeAutoClaimMandatory(cart, ui.tierIdx);
    }
    return ui;
  }
  function syncLastTierIndex(cart, tierIdx) {
    if (tierIdx < 0) return;
    if (needsGiftPicker(cart, tierIdx)) return;
    if (tierIdx > state.lastTierIndex) state.lastTierIndex = tierIdx;
  }

  function refresh(cart, opts) {
    opts = opts || {};
    if (!state.tiers.length && !legacyGiftThresholdMinor()) return Promise.resolve();

    cart = normalizeCart(cart || { items: [], item_count: 0, total_price: 0 });
    bootstrapTierIndex(cart);
    var ui = updateUI(cart);

    if (opts.uiOnly || opts.skipSync || state.claimingGift || state.syncInFlight) {
      /* Auto-popup only when explicitly requested (real unlock path uses onTierUnlocked) */
      if (ui && ui.tierIdx >= 0 && opts.allowPopup === true) {
        maybeAutoOpenGiftPopup(cart, ui.tierIdx, opts);
      }
      return Promise.resolve(ui);
    }

    bumpSync();
    var syncId = syncScheduleId;
    return runFullSync(cart, syncId).then(function () {
      return ui;
    });
  }

  function isActive() {
    return !!(state.offer && state.tiers.length);
  }

  function wireLadderClicks() {
    if (document.documentElement.dataset.mmCtgLadderWired) return;
    document.documentElement.dataset.mmCtgLadderWired = '1';
    document.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('[data-mm-ctg-remove-discount]');
      if (removeBtn) {
        e.preventDefault();
        e.stopPropagation();
        var code = removeBtn.getAttribute('data-mm-ctg-remove-discount');
        if (!code || removeBtn.disabled) return;
        removeBtn.disabled = true;
        removeDiscountCode(code)
          .then(function () {
            if (state.popupOpen && state.pickerTier) openPopup(state.pickerTier);
          })
          .catch(function () {
            removeBtn.disabled = false;
          });
        return;
      }
      var step = e.target.closest('.mm-ctg-step.is-unlocked');
      if (!step || !step.closest('[data-mm-tier-gifts-slot]')) return;
      if (isBusy()) return;
      var ladder = step.closest('.mm-ctg-ladder');
      if (!ladder) return;
      var steps = ladder.querySelectorAll('.mm-ctg-step');
      var idx = Array.prototype.indexOf.call(steps, step);
      if (idx < 0 || idx >= state.tiers.length) return;
      var tier = state.tiers[idx];
      if (!tier || !tierChoiceGifts(tier).length) return;
      e.preventDefault();
      e.stopPropagation();
      clearGiftOptOut(tier);
      state.popupPromptedTier = -1;
      openPopup(tier);
    });
  }

  function wireCartListeners() {
    if (document.documentElement.dataset.mmCtgCartWired) return;
    document.documentElement.dataset.mmCtgCartWired = '1';
    document.addEventListener('cart:updated', function (e) {
      if (!e.detail || !e.detail.cart) return;
      try {
        var cart = normalizeCart(e.detail.cart);
        /* updateUI → onTierUnlocked handles the single auto-open on real unlock */
        updateUI(cart);
        if (!state.claimingGift && !state.syncInFlight) scheduleSync(cart);
      } catch (err) {
        console.warn('[MM Cart Tier Gifts] cart:updated handler failed:', err);
      }
    });
    document.addEventListener('mm:offers-updated', function (e) {
      var data = e.detail && e.detail.data;
      if (!data) return;
      var hadTiers = state.tiers.length > 0;
      applyOffersPayload(data);
      if (state.tiers.length) {
        activateTierGiftsUi();
        fetchCart()
          .then(function (cart) { refresh(cart, { uiOnly: hadTiers, allowPopup: false }); })
          .catch(function () {
            refresh({ items: [], item_count: 0, total_price: 0 }, { uiOnly: true, allowPopup: false });
          });
      } else if (!hadTiers) {
        showGiftBarInactive(isAr()
          ? 'فعّل عرض CART_TIER_GIFT من لوحة التحكم'
          : 'Enable a CART_TIER_GIFT offer in admin');
      }
    });
  }

  function activateTierGiftsUi() {
    if (!state.tiers.length) return;
    tierGiftSlots().forEach(function (slot) {
      slot.hidden = false;
      slot.removeAttribute('aria-hidden');
    });
    wireCartListeners();
    wireLadderClicks();
    buildPopup();
    if (state.uiActivated) {
      fetchCart()
        .then(function (cart) { updateUI(cart); syncGiftFooterBtn(cart); })
        .catch(function () {});
      return;
    }
    state.uiActivated = true;
    fetchCart()
      .then(function (cart) {
        return refresh(cart, { allowPopup: false }).then(function () {
          state.unlockReady = true;
          syncGiftFooterBtn(cart);
        });
      })
      .catch(function () {
        refresh({ items: [], item_count: 0, total_price: 0 }, { uiOnly: true, allowPopup: false });
        state.unlockReady = true;
        syncGiftFooterBtn(null);
      });
  }

  function syncGiftFooterBtn(cart) {
    var btn = document.getElementById('mmCartSheetGiftBtn');
    if (!btn) return;
    cart = normalizeCart(cart || getCartSnapshot() || { items: [] });
    var total = qualifyingTotal(cart);
    var tierIdx = tierForTotal(total, state.tiers);
    var ready = canOpenGiftPicker(cart);
    var needs = ready && needsGiftPicker(cart, tierIdx);
    btn.hidden = false;
    btn.classList.toggle('is-ready', !!needs);
    btn.classList.toggle('is-locked', !ready);
    var ar = isAr();
    var label = ready
      ? (needs
        ? (ar ? 'اختر الهدية' : 'Choose gift')
        : (ar ? 'تغيير الهدية' : 'Change gift'))
      : (ar ? 'تفاصيل الهدايا' : 'Gift details');
    btn.setAttribute('aria-label', label);
    btn.setAttribute('title', label);
    var labelEl = btn.querySelector('[data-mm-open-gift-label]');
    if (labelEl) labelEl.textContent = label;
  }

  function init() {
    document.documentElement.setAttribute('data-mm-tier-gifts', '1');
    wireCartListeners();
    wireLadderClicks();

    if (bootstrapFromCache() && state.tiers.length) {
      updateUI({ items: [], item_count: 0, total_price: 0 });
      activateTierGiftsUi();
    }

    loadOffer().then(function () {
      if (state.tiers.length) {
        activateTierGiftsUi();
        return;
      }
      showGiftBarInactive(isAr()
        ? 'فعّل عرض CART_TIER_GIFT من لوحة التحكم'
        : 'Enable a CART_TIER_GIFT offer in admin');
    }).catch(function () {
      if (state.tiers.length) {
        activateTierGiftsUi();
        return;
      }
      showGiftBarInactive(isAr()
        ? 'تعذر تحميل عروض الهدايا. حدّث الصفحة.'
        : 'Could not load gift rewards. Refresh the page.');
    });
  }

  function isEligibleGiftLine(cart, item) {
    return isGiftLine(item) && giftShouldStay(cart || { items: [] }, item);
  }

  window.MMCartTierGifts = {
    init: init,
    refresh: refresh,
    updateUI: updateUI,
    scheduleSync: scheduleSync,
    bumpSync: bumpSync,
    purgeIneligible: purgeIneligibleGifts,
    optimisticCartLine: optimisticCartLine,
    qualifyingTotal: qualifyingTotal,
    loadOffer: loadOffer,
    isActive: isActive,
    isBusy: isBusy,
    isSyncing: isSyncing,
    isGiftLine: isGiftLine,
    isEligibleGiftLine: isEligibleGiftLine,
    onUserRemovedGift: onUserRemovedGift,
    releaseSheetUi: releaseSheetUi,
    openPicker: openPickerForCurrentTier,
    canOpenPicker: canOpenGiftPicker,
    openGiftOrDetails: openGiftOrDetails,
    enforce: function (cart) {
      cart = cart || { items: [], item_count: 0, total_price: 0 };
      return syncGiftEligibility(cart).then(function (result) {
        if (result.dirty) return publishCart(result.cart).then(function () { return updateUI(result.cart); });
        return updateUI(result.cart);
      });
    }
  };

  window.mmOpenGiftPopup = function () {
    if (window.MMCartTierGifts && typeof window.MMCartTierGifts.openGiftOrDetails === 'function') {
      window.MMCartTierGifts.openGiftOrDetails();
      return;
    }
    if (window.MMCartTierGifts && state.tiers.length) {
      window.MMCartTierGifts.openPicker();
      return;
    }
    if (typeof window.__mmLegacyGiftPopup === 'function') window.__mmLegacyGiftPopup();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
